import { render, staticRenderFns } from "./CheckExcesoVelocidad.vue?vue&type=template&id=be4e1848&scoped=true&"
import script from "./CheckExcesoVelocidad.vue?vue&type=script&lang=ts&"
export * from "./CheckExcesoVelocidad.vue?vue&type=script&lang=ts&"
import style0 from "./CheckExcesoVelocidad.vue?vue&type=style&index=0&id=be4e1848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4e1848",
  null
  
)

export default component.exports